import { render } from "./HistoricoPagamentos.vue?vue&type=template&id=37159614"
import script from "./HistoricoPagamentos.vue?vue&type=script&lang=js"
export * from "./HistoricoPagamentos.vue?vue&type=script&lang=js"

import "./HistoricoPagamentos.vue?vue&type=style&index=0&id=37159614&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__